// タブ/ウィンドウのタイトル。**組み立てはここ1箇所**にまとめる。
//
//   ポータル   … `HONGSOFT.JP GAMES`（登録済みなら `HONGSOFT.JP GAMES（名前）`）
//   ゲーム中   … `二角取り Solitaire | HONGSOFT.JP GAMES`
//   規約類     … `プライバシーポリシー | HONGSOFT.JP GAMES`（[legalPage.ts](../legal/legalPage.ts) が組む）
//
// **サイト名は翻訳しない**（固有名詞）。カタログに置くのは「並べ方」だけで、
// 区切りは規約ページに合わせて ` | ` に統一してある。
//
// ゲーム名は `portal.game.<key>.name` ＝ **ポータルのカタログ**から引く。
// boot で必ず読んでいるので、ゲーム本体のカタログを待たずに出せる。
import { t } from '@/platform/i18n';

/** ポータル（ダッシュボード）を出しているときのタイトル。 */
export function setPortalTitle(nickname: string | null): void {
  const name = nickname?.trim();
  document.title = name ? t('portal.docTitleNamed', { name }) : t('portal.docTitle');
}

/**
 * ゲームを遊んでいるときのタイトル。
 * 未知のキーはタイトルを触らない（カードとレジストリが食い違ったときに
 * `portal.game.xxx.name` をタブへ出さないため）。
 */
export function setGameTitle(gameKey: string): void {
  const key = `portal.game.${gameKey}.name`;
  const game = t(key);
  if (game === key) return; // `t()` は未知のキーをそのまま返す＝カタログに無い
  document.title = t('portal.docTitleGame', { game });
}
